import React from 'react';
import { formatChangeValue, formatField } from './TimelineUtils';
import { PrimitiveFieldChange } from 'interfaces';
import { ChangeItem } from './ChangeItem';
import { IconRefresh } from '@tabler/icons-react';
import { useTranslation } from '@refinedev/core';

interface PrimitiveChangeProps {
  changeDetails: PrimitiveFieldChange;
  field: string;
  status: any[];
  providers: any[];
  red: string;
  green: string;
}

export const PrimitiveChange: React.FC<PrimitiveChangeProps> = ({
  changeDetails,
  field,
  status,
  providers,
  red,
  green,
}) => {
  const { translate } = useTranslation();
  const { before, after } = changeDetails;
  const formattedField = formatField(field);
  const objectSummary = {
    detailsUpdated: translate(
      'pages:claims.claimHistory.values.detailsUpdated',
      'Details updated'
    ),
    itemCount: (count: number) =>
      translate(
        'pages:claims.claimHistory.values.itemCount',
        { count },
        `${count} item${count === 1 ? '' : 's'}`
      ),
  };
  const formattedBefore = formatChangeValue(
    before,
    field,
    status,
    providers,
    objectSummary
  );
  const formattedAfter = formatChangeValue(
    after,
    field,
    status,
    providers,
    objectSummary
  );

  return (
    <div data-testid="primitive-change">
      <ChangeItem
        label={formattedField}
        before={formattedBefore}
        after={formattedAfter}
        red={red}
        green={green}
        chip="Changed"
        icon={<IconRefresh size={14} />}
        iconColor="blue"
      />
    </div>
  );
};
